@if (
  {
    initiallyExpandedWorkspaceIds: initiallyExpandedWorkspaceIds$ | async,
  };
  as data
) {
  @for (group of groups; track groupTrackBy(i, group); let i = $index) {
    <div
      [hidden]="maxItems !== null && i >= maxItems"
      data-testid="user-picker-group"
      [attr.data-group-id]="group.id"
    >
      <!-- Expandable -->
      @if (group.isExpandable) {
        <app-user-picker-expandable-group
          [group]="group"
          [stickyHeaderTop]="46"
          [multiple]="multiple"
          [hideLabels]="hideLabels"
          [isInitiallyExpanded]="
            data.initiallyExpandedWorkspaceIds.has(group.id)
          "
        ></app-user-picker-expandable-group>
      } @else {
        @if ((hideTeams$ | async) === false || !group.isTeams) {
          <div class="sticky-container">
            @if (stickyGroupHeaders && (group.name || group.description)) {
              <div class="sticky">
                <h4 class="mat-body-2 name">
                  {{ group.name }}
                </h4>
                @if (group.description) {
                  <div class="mat-body celo-grey">
                    {{ group.description }}
                  </div>
                }
                <mat-divider id="divider"></mat-divider>
              </div>
            }
            @if (
              isNetworkUserPicker &&
              group.id ===
                UserSelectionListId.PEOPLE_IDENTITY_VERIFICATION_AND_DISCOVERABILITY &&
              group.data?.length === 0
            ) {
              <app-user-picker-no-suggestions
                [compact]="true"
              ></app-user-picker-no-suggestions>
            } @else {
              <app-user-picker-selection-list
                [group]="group"
                [multiple]="multiple"
                [hideLabels]="hideLabels"
              ></app-user-picker-selection-list>
            }
          </div>
        }
      }
      <!-- Not Expandable -->
    </div>
  }
}
